import { Grid } from "antd";
import { FC, HTMLAttributes } from "react";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import PassengerSelectWeb from "./layouts/PassengerSelect.web";
import PassengerSelectMob from "./layouts/PassengerSelect.mob";

const PassengerSelectComponent = withConditionalComponent(PassengerSelectWeb, PassengerSelectMob);

const PassengerSelect: FC<{ wrapperProps?: HTMLAttributes<HTMLDivElement> }> = ({ wrapperProps }) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  return <PassengerSelectComponent trigger={isLargeScreen} props={{ wrapperProps }} />;
};

export default PassengerSelect;
